import { EDCOMP_NOTEBOOK, EDCOMP_PROBLEM_SET } from "../../constants/frameConstants";


// Organizes the problems into a suitable format for progress display in TOC panel
export function preprocess_problems_solved(problemIds, problemsSolved){
    var preprocessed_problems = [] 
    var current_problem_index = 0;
    for(var c_content = 0; c_content < problemIds.length; c_content++){
        var this_preprocessed_problem = []
        for(var c_problem =0 ; c_problem < problemIds[c_content].ids.length; c_problem++){
            if(problemIds[c_content].indices[c_problem]!==current_problem_index){
                current_problem_index++
                preprocessed_problems.push(this_preprocessed_problem)
                this_preprocessed_problem = []
            }
            this_preprocessed_problem.push({set_name:problemIds[c_content].set_names[c_problem], set_id: problemIds[c_content].set_ids[c_problem], index:problemIds[c_content].indices[c_problem],solved:problemsSolved.includes(problemIds[c_content].ids[c_problem]),  type:problemIds[c_content].type[c_problem], })
        }
        if(this_preprocessed_problem.length>0){
            preprocessed_problems.push(this_preprocessed_problem)
        }
        current_problem_index++      
    }
    return preprocessed_problems; 
}

// Return the number of problems and the number done correctly
export function calculate_progress(problemIds, problemsSolved){
    let n_problem = 0;
    let n_solved = 0; 
    for(let c_content = 0; c_content < problemIds.length; c_content++){
        if (problemIds[c_content].ids.length> 0){
            n_problem += problemIds[c_content].ids.length
            const my_reducer = (accumulator, currentSolvedID) => {return(accumulator + problemIds[c_content].ids.includes(currentSolvedID))};
            n_solved+= problemsSolved.reduce(my_reducer,0)
        }
    }
    const return_vals = {n_problem: n_problem, n_solved: n_solved}
    return return_vals
}

// Returns percentage of exercises complete
export const calcPercentExercisesComplete = (problemIds, problemsTriedAndAnswers)=>{
    const problemsTried = problemsTriedAndAnswers.map(a => a.problemId);
    const progress = calculate_progress(problemIds, problemsTried)
    return 100.0 * progress.n_solved / progress.n_problem
}


// Extract the problem indices into separate structure to make it easier to measure progress
export function preprocess_problems(data){
    let problemIds = [] ; 
    var currentIndex = 0 ; 

    for (let c_section = 0; c_section < data?.length; c_section++)
    {
        let contentProblems={id:data[c_section]._id, set_ids:[], ids:[], indices:[], type:[], set_names:[]}
        for (let c_subsection  = 0; c_subsection< data[c_section]?.subsections?.length; c_subsection++)
        {
            for (let c_frame = 0; c_frame < data[c_section]?.subsections[c_subsection].frames?.length; c_frame++)
            {
                for (let c_item = 0; c_item < data[c_section]?.subsections[c_subsection].frames[c_frame].contents?.length; c_item++)
                {
                    if(data[c_section]?.subsections[c_subsection].frames[c_frame].contents[c_item].type===EDCOMP_PROBLEM_SET){
                      
                        let problems_seen = [false,false,false,false,false,false,false,false]
                        for(let c_problem = 0; c_problem < data[c_section]?.subsections[c_subsection].frames[c_frame].contents[c_item]?.data.problems.length; c_problem++)
                        {
                            let problem_index = data[c_section]?.subsections[c_subsection].frames[c_frame].contents[c_item]?.data.problems[c_problem].problem_index
                            if(!problems_seen[problem_index]){
                                problems_seen[problem_index] = true
                                contentProblems.ids.push(data[c_section]?.subsections[c_subsection].frames[c_frame].contents[c_item]?.data.problems[c_problem]._id)
                                contentProblems.indices.push(currentIndex)
                                contentProblems.type.push(EDCOMP_PROBLEM_SET)
                                contentProblems.set_ids.push(data[c_section]?.subsections[c_subsection].frames[c_frame].contents[c_item]._id)
                                contentProblems.set_names.push(data[c_section]?.subsections[c_subsection].frames[c_frame].contents[c_item].title)

                            }
                        }
                        currentIndex++
                    }
                    if(data[c_section]?.subsections[c_subsection].frames[c_frame].contents[c_item].type===EDCOMP_NOTEBOOK){
                        contentProblems.ids.push(data[c_section]?.subsections[c_subsection].frames[c_frame].contents[c_item]._id)
                        contentProblems.indices.push(currentIndex)
                        contentProblems.type.push(EDCOMP_NOTEBOOK)
                        contentProblems.set_ids.push(data[c_section]?.subsections[c_subsection].frames[c_frame].contents[c_item]._id)
                        contentProblems.set_names.push(data[c_section]?.subsections[c_subsection].frames[c_frame].contents[c_item].title)
                        currentIndex++ 
                    }
                }
            }
        }
        if(contentProblems.ids.length>0){
            problemIds.push(contentProblems)
        }
    }
    return problemIds; 
}